import React from 'react';
import { useAuth } from '../../context/AuthContext';
import DemoBanner from '../DemoBanner/DemoBanner';

/**
 * Route wrapper that allows both authenticated and unauthenticated access.
 * Unauthenticated users see a demo banner; pages should use demo data when
 * `user` is null.
 */
const DemoRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '60px 20px', color: '#555' }}>Loading...</div>;
  }

  return (
    <>
      {!user && <DemoBanner />}
      {children}
    </>
  );
};

export default DemoRoute;
